import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b014396e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "pa-4 teal--text" }
const _hoisted_4 = {
  key: 1,
  class: "error-msg"
}

import { IOptionsSelect } from '@/types';
import { withDefaults, watch, computed } from 'vue';
import {
	CalendarIcon
} from '../atoms';
interface IProps {
	modelValue?: any;
	options?: IOptionsSelect[];
	placeholder?: string;
	label?: string;
	width?: string;
	multiple?: boolean;
	disabled?: boolean;
	isCalendar?: boolean;
	required?: boolean;
	hasError?: boolean;
	msgError?: string;
	enableLoad: boolean;
	onLoad: any;
	handleSearch?: ((value) => any)
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomSelect',
  props: {
    modelValue: {},
    options: {},
    placeholder: { default: 'Selecione' },
    label: {},
    width: { default: 'auto' },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean },
    isCalendar: { type: Boolean, default: false },
    required: { type: Boolean },
    hasError: { type: Boolean },
    msgError: {},
    enableLoad: { type: Boolean, default: false },
    onLoad: { default: () => { /*console.log("default")*/ } },
    handleSearch: {}
  },
  emits: ['onChangeDropDownList', 'update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

function handleChangeDropdownList() {
	emit('onChangeDropDownList', selectedItem.value);
}

const selectedItem = computed({
	get: () => props.modelValue,
	set: (value) => emit('update:modelValue', value)
})

// const handleSearch = (text) => { console.log(text) }

watch(
	() => props.options,
	() => {
		if (!selectedItem.value)
			selectedItem.value = props.options?.find((x) => x.selected === true)?.value;
		emit("onChangeDropDownList", selectedItem.value);
	}
);


return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ width: props.width }),
    class: ""
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_v_autocomplete, {
      "item-title": "text",
      modelValue: selectedItem.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
        handleChangeDropdownList
      ],
      density: "compact",
      variant: "solo-inverted",
      "bg-color": "#F8F9FA",
      color: "primary",
      class: "border rounded-lg",
      placeholder: props.placeholder,
      items: props.options,
      multiple: _ctx.multiple,
      required: _ctx.required,
      chips: _ctx.multiple,
      disabled: props.disabled,
      "item-value": "value",
      clearable: true,
      "closable-chips": "",
      "onUpdate:search": _ctx.handleSearch,
      "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => {selectedItem.value = undefined;})
    }, _createSlots({ _: 2 }, [
      (props.isCalendar)
        ? {
            name: "selection",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(CalendarIcon))
              ])
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.enableLoad)
        ? {
            name: "append-item",
            fn: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(" Carregando... ")
              ])), [
                [_directive_intersect, _ctx.onLoad]
              ])
            ]),
            key: "1"
          }
        : undefined
    ]), 1032, ["modelValue", "placeholder", "items", "multiple", "required", "chips", "disabled", "onUpdate:search"]),
    (_ctx.hasError && _ctx.msgError)
      ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.msgError), 1))
      : _createCommentVNode("", true)
  ], 4))
}
}

})